var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkIcon = function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.66,
    height: 16.658
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108713",
    d: "M15.233 1.428a4.886 4.886 0 0 0-6.9 0l-.46.46a.651.651 0 0 0 0 .92l.92.92a.651.651 0 0 0 .92 0l.46-.46a2.278 2.278 0 0 1 3.221 3.221l-2.3 2.3a2.291 2.291 0 0 1-3.066.141l-.5-.417a.651.651 0 0 0-.917.082l-.834 1a.651.651 0 0 0 .083.916l.5.417a4.852 4.852 0 0 0 6.574-.3l2.3-2.3a4.88 4.88 0 0 0 0-6.9Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108714",
    d: "M7.87 12.929a.651.651 0 0 0-.92 0l-.46.46a2.278 2.278 0 0 1-3.221-3.221l2.3-2.3a2.29 2.29 0 0 1 3.066-.141l.5.417a.65.65 0 0 0 .917-.082l.834-1a.651.651 0 0 0-.083-.916l-.5-.417a4.852 4.852 0 0 0-6.574.3l-2.3 2.3a4.88 4.88 0 0 0 6.9 6.9l.46-.46a.651.651 0 0 0 0-.92Z",
    fill: "#707070"
  })));
};
export default SvgLinkIcon;